module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/client/favicon.ico
// module id = 1127
// module chunks = 0